import { useCallback, useState } from 'react';
import { AxiosRequestConfig } from 'axios';

import { IAvailableInviteSlotsParams } from '../../../../../../../../interfaces/officeHours';
import OfficeHoursService from '../../../../../../../../services/OfficeHoursService';

const useTotalSlots = () => {
  const [scheduledSlotsTotal, setScheduledSlotsTotal] = useState(0);
  const [upcomingSlotsTotal, setUpcomingSlotsTotal] = useState(0);

  const loadSlots = useCallback(
    async (
      params: IAvailableInviteSlotsParams,
      config: AxiosRequestConfig = {},
    ) => {
      const { total } = await OfficeHoursService.getAvailableTotalInviteSlots(
        params,
        config,
      );

      return {
        total,
      };
    },
    [],
  );

  const loadUpcomingSlots = useCallback(
    async (eventId: string) => {
      try {
        const { total } = await loadSlots({
          isScheduled: false,
          eventId,
        });
        setUpcomingSlotsTotal(total);
      } catch (e) {
        //
      }
    },
    [loadSlots],
  );

  const loadScheduledSlots = useCallback(
    async (eventId: string) => {
      try {
        const { total } = await loadSlots({
          isScheduled: true,
          eventId,
        });
        setScheduledSlotsTotal(total);
      } catch (e) {
        //
      }
    },
    [loadSlots],
  );

  return {
    upcomingSlotsTotal,
    scheduledSlotsTotal,
    loadUpcomingSlots,
    loadScheduledSlots,
    setScheduledSlotsTotal,
    setUpcomingSlotsTotal,
  };
};

export default useTotalSlots;
